/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Created_SuccessInputs */



/**
* | output |
* | --- |
* | "Issue created successfully" |
*
* @param {Manual_Qc_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_created_success = /** @type {((inputs?: Manual_Qc_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incident cree avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem erfolgreich erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema creato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблема успешно создана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema creado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题已成功创建")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題が正常に作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या सफलतापूर्वक बनाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema criado com sucesso")
	return /** @type {LocalizedString} */ ("Issue created successfully")
});